import React, { useState, useEffect, useMemo } from 'react';
// Third-party libraries
import { connect } from "react-redux"
// UI - Material UI
import withStyles from '@material-ui/core/styles/withStyles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Button, Grid, Typography, Input, Backdrop, CircularProgress } from '@material-ui/core'
import ModalCommon from '../../common/Modal/ModalCommon'
// Local files
import { FormatNumberMXN } from "../../common/Utils";
import { Icon } from 'antd';
import Modal from 'antd/es/modal';
import { useHistory } from 'react-router-dom'
import { ColumnsOrderHistoryChangeErrorsInvoices } from './ColumnsOrderHistoryChangeErrorsInvoices'
import DataTable from 'react-data-table-component';
import { customStyleSecondary } from '../../common/CommonStyles';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
const MuiAccordion = withStyles({
    root: {
        "&$expanded": {
            margin: "auto",
            border: '1px solid rgba(125, 155, 193)',
        }
    },
    expanded: {}
})(Accordion);

const OrderInvoiceChange = ({ classes, cleanFiles, orderId, t, setCompletInvoice, ...props }) => {

    //Accodeon component
    const [showComponentGeneral, setShowComponentGeneral] = useState(true);
    const [showComponentDetail, setShowComponentDetail] = useState(true);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [data, setData] = useState({});
    const [dataPaymentOrderErrorLogDTO, setDataPaymentOrderErrorLogDTO] = useState([])
    const [disableComponent, setDisableComponent] = useState(false);
    const history = useHistory()
    const paginationOptions = {
        rowsPerPageText: t('commonMessages.rowsPerPage'),
        rangeSeparatorText: t('common.to'),
        selectAllRowsItem: true,
        selectAllRowsItemText: t('common.all')
    }
    const [openModalDeleteInvoice, setOpenModalDeleteInvoice] = useState(false);
    // Handle to |Accordeon
    const toggleAcordionGeneral = () => {
        setShowComponentGeneral((prev) => !prev);
    };
    const toggleAcordionDetail = () => {
        setShowComponentDetail((prev) => !prev);
    };
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    useEffect(() => {
        setData({});
        cleanFiles();
        GetOrderInvoice();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if(!openModalDeleteInvoice){
            document.body.style.overflow="initial";
        }
    }, [openModalDeleteInvoice]) // eslint-disable-line react-hooks/exhaustive-deps
    const SendOrderFile = () => {
        if (props.filePDF != null && props.fileXML != null) {
            handleOpenBackdrop()
            const formData = new FormData();
            formData.append('files', props.fileXML);
            formData.append('files', props.filePDF);
            props.actions.UpdateOrderInvoice(props.userLanguage, props.userToken, orderId, formData, onError, onSuccessUpdateOrderInvoice);
        } else {
            Modal.error({
                title: 'Error',
                content: t('OrderInvoceChange.ChangeInvoce.MsgErrorValidFiles')
            })
        }

    }

    const GetOrderInvoice = () => {
        handleOpenBackdrop()
        props.actions.GetInvoiceByOrder(props.userLanguage, props.userToken, orderId, onError, onSuccessGetInvoiceByOrder);
    }

    const onSuccessGetInvoiceByOrder = (response) => {
        handleCloseBackdrop();
        cleanFiles();
        if (response.status) {
            setData(response.orderInvoiceDTO ? response.orderInvoiceDTO : {});
            setDataPaymentOrderErrorLogDTO(response.paymentOrderErrorLogDTO)
            if(response.orderInvoiceDTO){
                setDisableComponent(true);
            }else{
                if(props.data.activeUploadInvoice){
                    setDisableComponent(false);
                }else{
                    setDisableComponent(true);
                }
            }
            //setDisableComponent(response.orderInvoiceDTO ? true : false);
            //props.data.activeUploadInvoice? !props.data.activeUploadInvoice
            setCompletInvoice(response.completeInvoice)
        } else {
            setData({});
            setDisableComponent(false);
        }
        document.body.style.overflow="initial";
    }

    const onSuccessUpdateOrderInvoice = (response) => {
        handleCloseBackdrop();
        if(response.status){
            Modal.success({
                content: t('OrderInvoceChange.ChangeInvoce.MsOkValidFiles'),
                onOk: () => onSuccessGetInvoiceByOrder(response)
            })
        }
        else{
            GetOrderInvoice();
            if(!response.isValid) {
                toast.error(t('OrderInvoceChange.ChangeInvoce.InvalidInvoice'), { className: classes.toastError });
            }
            else {
                toast.error(t('commonMessages.alert500'), { className: classes.toastError });
            }
             
        }
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    return;
                case 403:
                    history.push('/forbidden')
                    return;
                default:
                    break
            }
        }
        toast.error(t('commonMessages.alert500'), { className: classes.toastError });
    }
    // call to the delete invoice function
    const DeleteDocumentsInvoiceByOrder = () => {
        onCloseModal();
        handleOpenBackdrop()
        props.actions.DeleteDocumentsInvoiceByOrder(props.userLanguage, props.userToken, orderId, onError, onSuccessDeleteInvoiceByOrder);
    }
    // Open modal
    const onOpenModal = () => {
        setOpenModalDeleteInvoice(true);
    }

    // Close modal
    const onCloseModal = () => {
        setOpenModalDeleteInvoice(false);
       
    }
    const onSuccessDeleteInvoiceByOrder = (response) => {
        handleCloseBackdrop();
        Modal.success({
            content: t('OrderInvoceChange.ModalDeleteInvoice.MessageSuccessDelete'),
            onOk: () => onSuccessGetInvoiceByOrder(response)
        })
        
    }




    const handleDownloadDocument = () => {
        handleOpenBackdrop()
        const documentId = data.pymtOrdInvId;
        props.actions.download_document_by_id(
            props.userLanguage,
            props.userToken,
            { DocumentId: documentId, IsInvoice: true },
            onError, onSucessDownloadDocument
        )
    }

    const onSucessDownloadDocument = () => {
        handleCloseBackdrop();
    }

    return (
        <>
            <ModalCommon
                title={t(`OrderInvoceChange.ModalDeleteInvoice.Title`)}
                status='default'
                open={openModalDeleteInvoice}
                clickOpen={onCloseModal}
                clickSubmit={DeleteDocumentsInvoiceByOrder}
                submitButtonOff={false}
                closeButtonOff={false}
                submitButtonTitle={t(`OrderInvoceChange.ModalDeleteInvoice.ToolTipBlbBtnAccept`)}
                closeButtonTitle={t(`common.cancel`)}
                maxWidth='xs'
                fontSize="2rem"
                variant="h6"
                children={
                    <>
                        <br />
                        <Typography className={classes.White} style={{ textAlign: "center" }}>
                            <ErrorOutlineIcon style={{ fontSize: '60px', color: "#93721E" }} />
                        </Typography>
                        <br />
                        <Typography className={classes.White} style={{ textAlign: "center" }}>
                            <b>
                                {t(`OrderInvoceChange.ModalDeleteInvoice.MessageBody`)}
                            </b>
                        </Typography>
                    </>
                }
            ></ModalCommon>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <MuiAccordion defaultExpanded={true} border={4} expanded={showComponentDetail}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    style={{ backgroundColor: "#789AC1", minHeight: "37px", height: "37px" }}
                    IconButtonProps={{ onClick: toggleAcordionDetail, style: { display: "none" } }} >
                    <Typography variant="body2" style={{ color: "#fff" }}>{t('OrderInvoceChange.TitleChangeInvoce')}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ padding: 0 }}>
                    <Grid container>
                        <Grid container item xs={12}>&nbsp;</Grid>
                        <Grid container item xs={12}>

                            <Grid item xs={1}></Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" >
                                    <b>
                                        {t(`OrderInvoceChange.ChangeInvoce.FileXML`)}
                                        <span className={classes.RequeridSinAbsolue}>*</span>:
                                    </b>
                                </Typography>
                                <Input
                                    disabled={disableComponent}
                                    key={props.keyXML}
                                    fullWidth
                                    type="file"
                                    name="fileXML"
                                    onChange={props.checkFileTypeXML}
                                />
                            </Grid>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={3}></Grid>
                        </Grid>
                        <Grid container item xs={12}>&nbsp;</Grid>
                        <Grid container item xs={12}>

                            <Grid item xs={1}></Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" >
                                    <b>
                                        {t(`OrderInvoceChange.ChangeInvoce.FilePDF`)}
                                        <span className={classes.RequeridSinAbsolue}>*</span>:
                                    </b>
                                </Typography>
                                <Input
                                    disabled={disableComponent}
                                    key={props.keyXML}
                                    fullWidth
                                    type="file"
                                    name="filePDF"
                                    onChange={props.checkFileTypePDF}
                                />

                            </Grid>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={3} alignContent='flex-end' textAlign="center">
                                <Button
                                    style={{ width: 160, marginBottom: 5 }}
                                    disabled={!(props.filePDF && props.fileXML)}
                                    variant="outlined"
                                    type="button"
                                    className={classes.generalBorderWithOutUpperCase}
                                    onClick={SendOrderFile}>
                                    {t('OrderInvoceChange.ChangeInvoce.BtnUpload')}
                                </Button>

                            </Grid>
                        </Grid>
                        <Grid container item xs={12}>&nbsp;</Grid>
                    </Grid>

                </AccordionDetails>
            </MuiAccordion>
            <MuiAccordion defaultExpanded={true} expanded={showComponentGeneral} >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    id="panel1a-header"
                    style={{ backgroundColor: "#789AC1", minHeight: "37px", height: "37px" }}
                    IconButtonProps={{ onClick: toggleAcordionGeneral, style: { display: "none" } }}
                >
                    <Typography variant="body2" style={{ color: "#fff" }}>{t('OrderInvoceChange.TitleInvoiceDetails')}</Typography>

                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <Grid container item xs={12}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.UUID`)}</b></Typography>
                                <Typography variant="body2">{data.invUuid}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.Date`)}</b></Typography>
                                <Typography variant="body2">{data.invCreationDtTm}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.SeriesFolio`)}</b></Typography>
                                <Typography variant="body2">{data.seriesFolio}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.State`)}</b></Typography>
                                <Typography variant="body2">{data.ordStatDescription}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} style={{ marginTop: 20 }}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.Subtotal`)}</b></Typography>
                                <Typography variant="body2">{data.invSubTotalAmt ? FormatNumberMXN(data.invSubTotalAmt ?? 0) : ''}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.Discount`)}</b></Typography>
                                <Typography variant="body2">{data.hasOwnProperty("invDiscAmt") ? FormatNumberMXN(data.invDiscAmt ?? 0) : ''}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.Vat`)}</b></Typography>
                                <Typography variant="body2">{data.invVatTaxAmt ? FormatNumberMXN(data.invVatTaxAmt ?? 0) : ''}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Typography variant="body2" ><b>{t(`OrderInvoceChange.InvoiceDetails.Total`)}</b></Typography>
                                <Typography variant="body2">{data.invTotalAmt ? FormatNumberMXN(data.invTotalAmt ?? 0) : ''}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} style={{ marginTop: 20 }}>
                            <Grid item xs={12} sm={6} md={6} style={{ textAlign: "right" }}>
                                <Button
                                    disabled={!(data.hasOwnProperty("pymtOrdInvId") ? true : false)}
                                    style={{ width: 160, marginRight: 100 }}
                                    type="button"
                                    className={classes.generalBorderWithOutUpperCase}
                                    variant="outlined"
                                    startIcon={<Icon type="download" style={{ fontSize: '15px' }} />}
                                    onClick={handleDownloadDocument}>

                                    {t('OrderInvoceChange.InvoiceDetails.BtnDownload')}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} style={{ textAlign: "left" }}>
                                <Button
                                    disabled={data.hasOwnProperty("activeDeleteInvoice") ? !data.activeDeleteInvoice : true}
                                    style={{ width: 160, marginLeft: 15 }}
                                    type="button"
                                    startIcon={<DeleteIcon style={{ fontSize: '15px' }} />}
                                    className={classes.generalBorderWithOutUpperCase}
                                    variant="outlined"
                                    onClick={onOpenModal}>
                                    {t('OrderInvoceChange.InvoiceDetails.BtnDelete')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </MuiAccordion>
            <MuiAccordion defaultExpanded={true} expanded={showComponentGeneral}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    id="panel3a-header"
                    style={{ backgroundColor: "#789AC1", minHeight: "37px", height: "37px" }}
                    IconButtonProps={{ onClick: toggleAcordionGeneral, style: { display: "none" } }}
                >
                    <Typography variant="body2" style={{ color: "#fff" }}>{t('OrderInvoceChange.TitleCHnageHistoryErrorInvoice')}</Typography>

                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <Grid container item xs={12}>
                            <DataTable
                                columns={ColumnsOrderHistoryChangeErrorsInvoices(t)}

                                data={dataPaymentOrderErrorLogDTO}
                                customStyles={customStyleSecondary}
                                fixedHeader={true}
                                fixedHeaderScrollHeight={'1200px'}
                                highlightOnHover
                                pointerOnHover
                                responsive
                                striped
                                pagination
                                paginationComponentOptions={paginationOptions}
                                noHeader
                                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </MuiAccordion>
            <ToastContainer />
        </>
    )
}

const mapStateToProps = state => ({
    orderDetails: state.OrderReducer.OrderDetails,
})


const mapDispatchToProps = (dispatch) => {
    return {
        tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderInvoiceChange)
